import React from 'react';

import { ILockInfo } from './types';

export const LockContext = React.createContext<ILockInfo | null>({
  lock: () => null,
  unlock: () => null,
  locked: false,
  user: null,
});
